/**
 * @generated SignedSource<<08a653c659fc1c07921cf243e2c26ccf>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type FrequencyPeriod = "Day" | "Hour" | "Month" | "Week" | "Year";
export type OfferEligibilityLevelType = "Account" | "Line" | "NA";
export type ProductBalanceManagementType = "POSTPAID" | "PREPAID";
export type ProductType = "CHARACTERISTIC" | "DEAL" | "FEATURE" | "MARKETING" | "ORIGINAL_RRP";
import { FragmentRefs } from "relay-runtime";
export type RelatedOfferFragment$data = ReadonlyArray<{
  readonly category: ReadonlyArray<{
    readonly id: string;
  }> | null;
  readonly contentKey: string | null;
  readonly contractTerm: {
    readonly name: string | null;
  } | null;
  readonly dataLayerCategory: string | null;
  readonly description: string | null;
  readonly entitlements: ReadonlyArray<{
    readonly contentKey: string | null;
    readonly iconUrl: string | null;
    readonly longDescription: string | null;
    readonly name: string;
    readonly shortDescription: string | null;
    readonly sortOrder: number | null;
  }> | null;
  readonly id: string;
  readonly name: string | null;
  readonly price: {
    readonly basePrice: number | null;
    readonly basePriceExcludingTax: number | null;
    readonly frequency: {
      readonly period: FrequencyPeriod;
      readonly value: number;
    } | null;
    readonly priceType: string;
  } | null;
  readonly productCharacteristics: {
    readonly balanceManagement: ProductBalanceManagementType | null;
    readonly offerEligibilityLevel: OfferEligibilityLevelType | null;
    readonly relatedOfferId: string | null;
    readonly relatedOfferIds: ReadonlyArray<string> | null;
  } | null;
  readonly productType: string | null;
  readonly promotions: ReadonlyArray<{
    readonly contentKey: string | null;
    readonly iconUrl: string | null;
    readonly longDescription: string | null;
    readonly name: string;
    readonly productType: ProductType;
    readonly shortDescription: string | null;
    readonly sortOrder: number | null;
  }> | null;
  readonly " $fragmentType": "RelatedOfferFragment";
}>;
export type RelatedOfferFragment$key = ReadonlyArray<{
  readonly " $data"?: RelatedOfferFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"RelatedOfferFragment">;
}>;

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "contentKey",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "productType",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "shortDescription",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "longDescription",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "iconUrl",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "sortOrder",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "plural": true
  },
  "name": "RelatedOfferFragment",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "description",
      "storageKey": null
    },
    (v1/*: any*/),
    (v2/*: any*/),
    (v3/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "Price",
      "kind": "LinkedField",
      "name": "price",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "priceType",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "PriceFrequency",
          "kind": "LinkedField",
          "name": "frequency",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "period",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "value",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "basePrice",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "basePriceExcludingTax",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Entitlement",
      "kind": "LinkedField",
      "name": "entitlements",
      "plural": true,
      "selections": [
        (v1/*: any*/),
        (v4/*: any*/),
        (v5/*: any*/),
        (v6/*: any*/),
        (v7/*: any*/),
        (v2/*: any*/)
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Promotion",
      "kind": "LinkedField",
      "name": "promotions",
      "plural": true,
      "selections": [
        (v1/*: any*/),
        (v4/*: any*/),
        (v5/*: any*/),
        (v3/*: any*/),
        (v7/*: any*/),
        (v2/*: any*/),
        (v6/*: any*/)
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ContractTerm",
      "kind": "LinkedField",
      "name": "contractTerm",
      "plural": false,
      "selections": [
        (v1/*: any*/)
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ProductCharacteristic",
      "kind": "LinkedField",
      "name": "productCharacteristics",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "balanceManagement",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "offerEligibilityLevel",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "relatedOfferId",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "relatedOfferIds",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "OfferDetailCategory",
      "kind": "LinkedField",
      "name": "category",
      "plural": true,
      "selections": [
        (v0/*: any*/)
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "dataLayerCategory",
      "storageKey": null
    }
  ],
  "type": "BaseOfferDetail",
  "abstractKey": null
};
})();

(node as any).hash = "a011b8e2956ae90915fa29d366b02b25";

export default node;
